import store from 'store'
import actions from './actions'

const STORED_APP_DATA = storedAppData => {
  const appData = {}
  Object.keys(storedAppData).forEach(key => {
    const item = store.get(`app.data.${key}`)

    appData[key] = typeof item !== 'undefined' ? item : storedAppData[key]
  })
  return appData
}
const initialState = {
  ...STORED_APP_DATA({
    data: [],
    meta: [],
    active: [],
    appCreated: [],
    appSettings: [],
    apikeysList: [],
    apikeysAuthList: [],
    apikeysRestList: [],
    apikeysActive: [],
    apikeySearchText: '',
    apikeyQuickStart: 'API_KEY',
    usersList: [],
    usersActive: [],
    usersActiveList: [],
    usersInactiveList: [],
    userSearchText: '',
    userInactiveSearchText: '',
    rolesList: [],
    rolesActive: [],
    roleSearchText: '',
    groupsList: [],
    groupsActive: [],
    groupSearchText: '',
    groupMemberSearchText: '',
    groupBannedMemberSearchText: '',
    groupUserSearchText: '',
    userNonGroupsList: [],
    groupMembersList: [],
    groupBannedMembersList: [],
    botsList: [],
    botsActive: [],
    builderList: [],
    buildersActive: [],
    agentBuilderList: [], // Agent builders specifically
    agentBuildersActive: [],
    extensionsAllList: [],
    extensionsInstalledList: [],
    sentManualIntentExtensionIds: [],
    extensionsActive: [],
    extensionsTypeActive: 'all',
    extensionSearchText: '',
    webhooksList: [],
    newWebhooksList: [],
    triggersList: [],
    newTriggersList: [],
    webhooksActive: [],
    newWebhooksActive: [],
    uAuthTokensList: [],
    uAuthTokenSearchText: '',

    // AI Agents state
    aiAgentsList: [],
    aiAgentsListTotal: 0,
    aiAgentsListPagination: {},
    aiAgentSearchText: '',
    areAiAgentsLoading: false,
    deletingAgentIds: [], // Track which agents are being deleted
    updatingAgentIds: [], // Track which agents are being updated
    aiAgentCreateForm: null,
    isAiAgentCreateFormLoading: false,
    aiAgentEditForm: null,
    isAiAgentEditFormLoading: false,
    aiAgentIntegrations: [],

    // AI Agents Builder state
    aiAgentsBuilderList: [],
    aiAgentsBuilderListTotal: 0,
    aiAgentsBuilderListPagination: {},
    aiAgentBuilderSearchText: '',
    areAiAgentsBuildersLoading: false,
    deletingAgentBuilderIds: [], // Track which agent builders are being deleted
    updatingAgentBuilderIds: [], // Track which agent builders are being updated
    activeBuilderAgent: null, // Currently selected agent builder
    isActiveBuilderAgentLoading: false,
    aiAgentBuilderCreateForm: null,
    isAiAgentBuilderCreateFormLoading: false,
    aiAgentBuilderEditForm: null,
    isAiAgentBuilderEditFormLoading: false,
    aiAgentBuilderIntegrations: [],
    // AI Tools state (for tools)
    aiToolsList: [],
    aiToolsListTotal: 0,
    aiToolsListPagination: {},
    aiToolSearchText: '',
    areAiToolsLoading: false,
    currentAiTool: null,
    isCurrentAiToolLoading: false,
    aiToolEditForm: null,
    // AI Actions state (separate from tools)
    aiActionsList: [],
    aiActionsListTotal: 0,
    aiActionsListPagination: {},
    aiActionSearchText: '',
    areAiActionsLoading: false,
    currentAiAction: null,
    isCurrentAiActionLoading: false,
    aiActionEditForm: null,
    isAiToolEditFormLoading: false,
    isAiActionEditFormLoading: false,
    aiToolCreateForm: null,
    isAiToolCreateFormLoading: false,
    aiActionCreateForm: null,
    isAiActionCreateFormLoading: false,

    // AI Tools Builder state
    aiToolsBuilderList: [],
    aiToolsBuilderListTotal: 0,
    aiToolsBuilderListPagination: {},
    aiToolBuilderSearchText: '',
    areAiToolsBuildersLoading: false,
    currentAiToolBuilder: null,
    isCurrentAiToolBuilderLoading: false,
    aiToolBuilderEditForm: null,
    isAiToolBuilderEditFormLoading: false,
    aiActionBuilderEditForm: null,
    isAiActionBuilderEditFormLoading: false,
    aiToolBuilderCreateForm: null,
    isAiToolBuilderCreateFormLoading: false,
    aiToolActionsList: [],
    aiToolActionsTotal: 0,
    aiToolActionsLoading: false,
    aiToolActionsPagination: {},
    currentAiToolActions: null,
    aiActionBuilderCreateForm: null,
    isAiActionBuilderCreateFormLoading: false,
    // Custom API Tools
    customApiToolsList: [],
    customApiToolsTotal: 0,
    customApiToolsLoading: false,
    customApiToolCreating: false,
    customApiToolUpdating: false,
    customApiToolsPagination: {},
    // Knowledge Base
    knowledgeBaseList: [],
    knowledgeBaseTotal: 0,
    knowledgeBaseLoading: false,
    knowledgeBasePagination: {},
    knowledgeBaseDetails: null,
    knowledgeBaseDetailsLoading: false,
    knowledgeBaseDetailsPagination: {},
    // MCP Servers
    mcpServersList: [],
    mcpServersTotal: 0,
    mcpServersLoading: false,
    mcpServersPagination: {},
    // Frontend Actions
    frontendActionsList: [],
    frontendActionsTotal: 0,
    frontendActionsLoading: false,
    frontendActionsError: null,
    frontendActionsPagination: {},
    frontendActionFormLoading: false,
    frontendActionDeleteLoading: false,
    // Available Models
    availableModels: [],
    availableModelsLoading: false,
    uFriendsList: [],
    uFriendsListTotal: 0,
    uFriendsListPagination: {},
    uGroupsList: [],
    uGroupsListTotal: 0,
    uGroupsListPagination: {},
    friendUserSearchText: '',
    userNonFriendsList: [],
    subscribePlanOngoingData: [],
    subscribePlanOngoingLink: '',
    subscribePlanAppData: [],
    subscribeTotalCharge: 0,
    subscribeDowngradeAtEOT: true,
    usersListTotal: 0,
    usersListActiveTotal: 0,
    usersListInactiveTotal: 0,
    apikeysListTotal: 0,
    apikeysListAuthTotal: 0,
    apikeysListRestTotal: 0,
    rolesListTotal: 0,
    groupsListTotal: 0,
    webhooksListTotal: 0,
    newWebhooksListTotal: 0,
    botsListTotal: 0,
    groupMembersListTotal: 0,
    groupBannedMembersListTotal: 0,
    stats: [],
    messageLogs: [],
    messageLogsLoadMoreId: 0,
    messageLogsPollingId: 0,
    messageLogsLoading: false,
    messageCategories: [],
    messageCategoriesLoading: false,
    messageSearchLogs: [],
    messageSearchLogsLoading: false,
    messageSearchExceedsLimit: false,
    chatWidgetsList: [],
    chatWidgetsCombinedList: [],
    chatWidgetAppUrl: false,
    chatWidgetActive: [],
    modMessageLogs: [],
    modMessageLogsLoadMoreId: 0,
    modMessageLogsLoading: false,
    groupsModerationList: [],
    groupsModerationListTotal: 0,
    groupsModerationActive: [],
    groupModerationSearchText: '',
    groupMessageLogs: [],
    groupMessageLogsLoading: false,
    teamCollaboratorsList: [],
    teamCollaboratorsListTotal: 0,
    teamCollaboratorsActive: [],
    teamLoggedInCollaborator: [],
    teamCollaboratorSearchText: '',
    metricsDcu: [],
    metricsHau: [],
    metricsCcu: [],
    metricsMau: [],
    metricsMcu: [],
    metricsPeak: [],
    metricsVoice: [],
    metricsVideo: [],
    metricsRecording: [],
    metricsAUCMinute: 0,
    metricsAUCHour: 0,
    metricsAUCDay: 0,
    metricsAUCMonth: 0,
    metricsAUCPeak: 0,
    metricsAVoMMonth: 0,
    metricsAViMMonth: 0,
    metricsAVoMToday: 0,
    metricsAViMToday: 0,
    metricsAReMToday: 0,
    metricsPlatform: [],
    metricsPlatformVersion: [],
    metricsVersionSupport: false,
    metricsPlanSupport: false,
    metricsPlatformVersionData: [],
    metricsLoading: false,
    metricsUpdateSuccess: false,
    appUsageAndOverages: [],
    fetchedInsightsData: [],
    appUsageAndOveragesLoading: false,
    appsListTotal: 0,
    appSearchText: '',
    appRolesFilter: '',
    appPlanFilter: '',
    appsListPageNo: 1,
    rolesPermissionsList: [],
    rolesPermissionsListTotal: 0,
    rolesActiveRestrictionList: [],
    rolesActiveRestrictionListTotal: 0,
    rolesPermissionsV2List: [],
    rolesPermissionsV2ListTotal: 0,
    rolesPermissionsV2Values: {},
    groupScopePermissionsList: [],
    groupScopePermissionsListTotal: 0,
    groupScopePermissionsValues: {},
    messageExportLogs: [],
    messageExportLogsLoading: false,
    messageExportAllExceedsLimit: false,
    callLogs: [],
    callSearchLogs: [],
    callSearchLogsLoading: false,
    callSearchLogsTotal: 0,
    callSearchLogsPagination: {},
    callSessionParticipants: [],
    callSessionParticipantsLegacy: [],
    callRecordings: [],
    messageActive: [],
    callActive: [],
    callActiveLegacy: [],
    callSearchLogsLegacy: [],
    billingInvoices: [],
    notification_type: 'info',
    notification_message: '',
    currentIntentRequest: '',
    userFriendSearchText: '',
    userGroupSearchText: '',
    nonParticipantSearchText: '',
    nonParticipantsList: [],
    nonParticipantsListTotal: 0,
    nonFriendList: [],
    nonFriendListTotal: 0,
    nonGroupList: [],
    nonGroupListTotal: 0,
    groupFriendSearchText: '',
    groupMembersListPagination: [],
    groupBannedMembersListPagination: [],
    uAuthTokensListTotal: 0,
    uAuthTokensListPagination: {},
    usersFilters: {},
    inactiveUsersFilters: {},
    groupsFilters: {},
    usersListPagination: {},
    rolesListPagination: {},
    usersListInactivePagination: {},
    groupsListPagination: {},
    nonFriendListPagination: {},
    nonGroupListPagination: {},
    webhooksListPagination: {},
    newWebhooksListPagination: {},
    botsListPagination: {},
    apikeysAuthListPagination: {},
    apikeysRestListPagination: {},
    nonParticipantsListPagination: {},
    appMessageSettings: {},
    loading: false,
    appLoadingInProgress: false,
    firstAppCreationInProgress: false,
    firstAppID: 0,
    areUsersLoading: false,
    areGroupsLoading: false,
    areRolesLoading: false,
    areWidgetsLoading: true,
    areWebhooksLoading: true,
    areWebhooksLegacyLoading: true,
    areBotsLoading: true,
    areBuildersLoading: true,
    areAIBotsLoading: true,
    areAIPersonalitiesLoading: true,
    areTeamMembersLoading: true,
    areApikeysLoading: true,
    moderationActivityList: [],
    moderationActivityListPagination: {},
    moderationActivityListTotal: 0,
    moderationFlaggedMessagesList: [],
    moderationFlaggedMessagesListPagination: {},
    moderationFlaggedMessagesListTotal: 0,
    moderationReviewedMessagesList: [],
    moderationReviewedMessagesListPagination: {},
    moderationReviewedMessagesListTotal: 0,
    moderationRulesList: [],
    moderationRulesListPagination: {},
    moderationRulesListTotal: 0,
    moderationRulesNonDefaultListTotal: 0,
    moderationRuleActive: [],
    moderationKeywordsList: [],
    moderationKeywordListTotal: 0,
    moderationKeywordNonDefaultListTotal: 0,
    moderationKeywordListPagination: {},
    areModerationSectionsLoading: false,
    isModerationActivityLoading: false,
    isModerationFlaggedMessagesLoading: false,
    isModerationReviewedMessagesLoading: false,
    areExtensionsLoading: false,
    moderationRuleRevisionsList: [],
    moderationRuleRevisionsListPagination: {},
    moderationRuleRevisionsListTotal: 0,
    moderationKeywordActive: [],
    moderationConfigurationList: [],
    moderationActivityListPaginationCurentParams: {},
    moderationFlaggedMessagesListPaginationCurrentParams: {},
    moderationReviewedMessagesListPaginationCurrentParams: {},
    moderationLocallyReviewedFlagIds: [],
    notificationLogs: [],
    notificationLogsPagination: {},
    notificationLogsTotal: 0,
    notificationLogsFilters: {},
    isNotificationLogsLoading: false,
    moderationOpenAICustomAPISettings: {},
    showAddCustomCategories: false,
    showEditCustomCategories: false,
    customCategoriesList: [],
    isCustomCategoriesLoading: false,
    // AI Agent Users
    aiAgentUserList: [],
    aiAgentUserListTotal: 0,
    aiAgentUserListText: '',
    aiAgentUserSearchText: '',
    areAIAgentUsersLoading: false,
    aiAgentUserListPagination: {},
    flaggedByUsers: [],
    flaggedByUsersTotal: 0,
    flaggedByUsersPagination: {},
  }),
}

export default function appsReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    case 'apps/INITIALIZE_AI_AGENTS_BUILDER_PAGE':
      return {
        ...state,
        lastCreatedAgentId: null,
        aiAgentsBuilderListPagination: {},
      }
    default:
      return state
  }
}
